/**
 * About page Mission / Vision expanding cards (sections/mission-vision.liquid).
 * Hovering, focusing or tapping a card makes that card the
 * active (wide) one and collapses the other. The last choice stays when the pointer leaves.
 */
class MissionVision extends HTMLElement {
  connectedCallback() {
    this.cards = [...this.querySelectorAll('[data-mv-card]')];
    if (this.cards.length < 2) return;

    this.cards.forEach((card, i) => {
      card.addEventListener('mouseenter', () => this.activate(i));
      card.addEventListener('focus', () => this.activate(i));
      card.addEventListener('click', () => this.activate(i));
    });
  }

  activate(index) {
    this.cards.forEach((card, i) => card.toggleAttribute('data-active', i === index));
  }
}

if (!customElements.get('mission-vision')) customElements.define('mission-vision', MissionVision);
